module.exports = __webpack_public_path__ + "static/img/testBanner.3fd66ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testBanner.png
// module id = MT59
// module chunks = 1